module.exports = __webpack_public_path__ + "assets/img/icon.0a6db8e3.png";